/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Trash, PencilSimpleLine, Plus, MagnifyingGlass, FunnelSimple, DotsThreeVertical } from "@phosphor-icons/react";
import api from "../../utils/api";
import permissions from "../Permissions/permissions1";
import { Eye, Download, Users, ChartBar, Clock, CheckCircle } from "lucide-react";
import ContentLoader from "react-content-loader";

const Sections = () => {
    const [fetchedData, setFetchedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [sectionName, setSectionName] = useState("");
    const [ID, setID] = useState(null);
    const [buttonText, setButtonText] = useState("Add Section");
    const [userPermissions, setUserPermissions] = useState({});
    const [searchTerm, setSearchTerm] = useState("");

    const [classes, setClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");

    const TableLoader = ({ rows = 10, columns = 3 }) => (
        <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
                            <div
                                style={{
                                    height: "20px",
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s infinite"
                                }}
                            ></div>
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );

    useEffect(() => {
        auth();
        fetchData();
        fetchClasses();
    }, []);

    async function auth() {
        setLoading(true);
        try {
            const loggedInUser = localStorage.getItem("loggedInUser");
            const role = localStorage.getItem("role");
            const token = localStorage.getItem("authToken");
            const programType = "getPagePermission";

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("role", role);
            fd.append("programType", programType);
            fd.append("limit", itemsPerPage);
            fd.append("pageNo", 1);

            const response = await api.post("user/userCurl", fd);
            if (response.data && response.data.data.length > 0) {
                setUserPermissions(response.data.data[0]);
            }
        } catch (error) {
            setUserPermissions({});
            toast.error("Error fetching permissions.");
        } finally {
            setLoading(false);
        }
    }

    async function fetchClasses() {
        try {
            const loggedInUser = localStorage.getItem("loggedInUser");
            const role = localStorage.getItem("role");
            const token = localStorage.getItem("authToken");

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("role", role);
            fd.append("programType", "getClasses");

            const response = await api.post("student/student", fd);

            console.log("classes", response)

            if (response.data?.status && Array.isArray(response.data.data)) {
                setClasses(response.data.data);
            }

        } catch (error) {
            toast.error("Error fetching classes.");
        }
    }

    async function fetchData(page = 1, classId = "") {
        setDataLoading(true);
        try {
            const loggedInUser = localStorage.getItem("loggedInUser");
            const role = localStorage.getItem("role");
            const token = localStorage.getItem("authToken");

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("role", role);
            fd.append("programType", "getSections");

            if (classId) {
                fd.append("class_id", classId);
            }

            const response = await api.post("student/student", fd);

            if (response.data && Array.isArray(response.data.data)) {
                setFetchedData(response.data.data);
            } else {
                setFetchedData([]);
            }

        } catch (error) {
            setFetchedData([]);
            toast.error("Error fetching sections.");
        } finally {
            setDataLoading(false);
        }
    }
    const handleEdit = (section) => {
        setSectionName(section.sectionName);
        setSelectedClass(section.class_id || "");
        setID(section.id);
        setButtonText("Update Section");
        setShow(true);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setButtonText(ID ? "Updating..." : "Adding...");

        try {
            const loggedInUser = localStorage.getItem("loggedInUser");
            const token = localStorage.getItem("authToken");
            const programType = ID ? "updateSection" : "addSection";

            const fd = new FormData();
            fd.append("sectionName", sectionName);
            fd.append("class_id", selectedClass);
            fd.append("programType", programType);
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);

            if (ID) {
                fd.append("id", ID);
            }

            const response = await api.post("student/student", fd);

            console.log("submit response", response)

            if (response.data.status === true) {
                toast.success(response.data.data);
                fetchData();
                setShow(false);
                setID(null);
            } else {
                toast.error(response.data.data);
            }
        } catch (error) {
            toast.error("Error submitting form.");
        } finally {
            setLoading(false);
            setButtonText("Add Section");
        }
    }



    async function handleDelete(id) {
        if (!window.confirm("Are you sure you want to delete this class?")) return;

        setLoading(true);
        try {
            const loggedInUser = localStorage.getItem("loggedInUser");
            const token = localStorage.getItem("authToken");
            const programType = "deleteSection";

            const fd = new FormData();
            fd.append("programType", programType);
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("id", id);

            const res = await api.post("student/student", fd);

            console.log("delete response", res)
            toast.success(res.data.data || "Section deleted successfully.");
            fetchData(currentPage);
        } catch (error) {
            toast.error("Error deleting class.");
        } finally {
            setLoading(false);
        }
    }

    const handleShowAdd = () => {
        setSectionName("");
        setSelectedClass("");
        setButtonText("Add Section");
        setID(null);
        setShow(true);
    };


    const handleClose = () => {
        setShow(false);
        setSectionName("");
        setID(null);
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchData(page, searchTerm);
        }
    };

    const createPagination = () => {
        const pageNumbers = [];
        const range = 2;
        const maxPageNumber = totalPages;

        pageNumbers.push(1);
        if (currentPage > range + 2) {
            pageNumbers.push("...");
        }
        for (
            let i = Math.max(currentPage - range, 2);
            i <= Math.min(currentPage + range, maxPageNumber - 1);
            i++
        ) {
            pageNumbers.push(i);
        }
        if (currentPage < maxPageNumber - range - 1) {
            pageNumbers.push("...");
        }
        if (maxPageNumber > 1) {
            pageNumbers.push(maxPageNumber);
        }

        return pageNumbers;
    };

    return (
        <div style={{
            minHeight: "100vh",
            background: "#f8fafc",
            padding: "24px",
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
        }}>
            {userPermissions.is_view === "0" ? (
                <div style={{ textAlign: "center", marginTop: "50px" }}>
                    <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
                </div>
            ) : (
                <>
                    {/* Header Section */}
                    <div style={{ marginBottom: "32px" }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                            flexWrap: "wrap",
                            gap: "16px"
                        }}>
                            <div>
                                <h1 style={{
                                    fontSize: "28px",
                                    fontWeight: "700",
                                    color: "#1e293b",
                                    margin: 0
                                }}>
                                    Section Management
                                </h1>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontSize: "14px",
                                    color: "#64748b",
                                    marginTop: "4px"
                                }}>
                                    <Link to="/" style={{ color: "#64748b", textDecoration: "none" }}>Home</Link>
                                    <span>/</span>
                                    <span style={{ color: "#3E80F9", fontWeight: "500" }}>Sections</span>
                                </div>
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                                {/* Search Bar */}
                                {/* Class Filter */}
                                <div>
                                    <select
                                        value={selectedClass}
                                        onChange={(e) => {
                                            const classId = e.target.value;
                                            setSelectedClass(classId);
                                            fetchData(1, classId);
                                        }}
                                        style={{
                                            padding: "12px 16px",
                                            borderRadius: "12px",
                                            border: "1px solid #e2e8f0",
                                            fontSize: "14px",
                                            width: "220px",
                                            outline: "none",
                                            background: "#fff",
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                                        }}
                                    >
                                        <option value="">All Classes</option>
                                        {classes.map((cls) => (
                                            <option key={cls.id} value={cls.id}>
                                                {cls.className}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {userPermissions.is_add === "1" && (
                                    <button
                                        onClick={handleShowAdd}
                                        style={{
                                            background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                                            color: "#fff",
                                            border: "none",
                                            padding: "12px 24px",
                                            borderRadius: "12px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            transition: "all 0.3s",
                                            boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                                        }}
                                        onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                                        onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                                    >
                                        <Plus size={20} weight="bold" />
                                        Add New Section
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Sectiones Table */}
                    <div style={{
                        background: "#fff",
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                        marginTop: "16px"
                    }}>
                        <div style={{ overflowX: "auto" }}>
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                minWidth: "600px",
                                fontSize: "13px"
                            }}>
                                <thead
                                    style={{
                                        background: "#f8fafc",
                                        borderBottom: "2px solid #e5e7eb"
                                    }}
                                >
                                    <tr>
                                        <th
                                            style={{
                                                width: "48px",
                                                minWidth: "48px",
                                                maxWidth: "48px",
                                                padding: "14px 8px",
                                                textAlign: "center",
                                                fontSize: "13px",
                                                fontWeight: "700",
                                                color: "#475569",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.4px",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            #
                                        </th>

                                        <th
                                            style={{
                                                padding: "14px 16px",
                                                textAlign: "left",
                                                fontSize: "13px",
                                                fontWeight: "700",
                                                color: "#475569",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.4px",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            Class
                                        </th>

                                        <th
                                            style={{
                                                padding: "14px 16px",
                                                textAlign: "left",
                                                fontSize: "13px",
                                                fontWeight: "700",
                                                color: "#475569",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.4px",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            Section
                                        </th>

                                        <th
                                            style={{
                                                padding: "14px 16px",
                                                textAlign: "center",
                                                fontSize: "13px",
                                                fontWeight: "700",
                                                color: "#475569",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.4px",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            Actions
                                        </th>
                                    </tr>
                                </thead>

                                {dataLoading ? (
                                    <TableLoader rows={6} columns={3} />
                                ) : (
                                    <tbody>
                                        {fetchedData.length === 0 ? (
                                            <tr>
                                                <td colSpan={3} style={{ padding: "40px", textAlign: "center" }}>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "12px",
                                                        color: "#94a3b8"
                                                    }}>
                                                        <div style={{
                                                            fontSize: "36px",
                                                            background: "#f1f5f9",
                                                            width: "60px",
                                                            height: "60px",
                                                            borderRadius: "50%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}>
                                                            🏫
                                                        </div>
                                                        <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                                                            No Sections found
                                                        </div>
                                                        <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                                                            {searchTerm ? "Try adjusting your search term" : "Create your first section"}
                                                        </div>
                                                        {!searchTerm && userPermissions.is_add === "1" && (
                                                            <button
                                                                onClick={handleShowAdd}
                                                                style={{
                                                                    background: "#3E80F9",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    padding: "8px 20px",
                                                                    borderRadius: "6px",
                                                                    fontSize: "13px",
                                                                    fontWeight: "500",
                                                                    cursor: "pointer",
                                                                    marginTop: "8px"
                                                                }}
                                                            >
                                                                Create First Section
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            fetchedData.map((section, index) => (
                                                <tr key={section.id} style={{
                                                    borderBottom: "1px solid #f1f5f9",
                                                    transition: "background 0.2s"
                                                }}>
                                                    <td
                                                        style={{
                                                            width: "48px",
                                                            minWidth: "48px",
                                                            maxWidth: "48px",
                                                            padding: "6px",
                                                            fontSize: "12px",
                                                            color: "#64748b",
                                                            fontWeight: "500",
                                                            textAlign: "center",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "26px",
                                                                height: "26px",
                                                                borderRadius: "6px",
                                                                background: "#f1f5f9",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontWeight: "600",
                                                                fontSize: "12px",
                                                                color: "#475569",
                                                                margin: "0 auto"
                                                            }}
                                                        >
                                                            {(currentPage - 1) * itemsPerPage + index + 1}
                                                        </div>
                                                    </td>

                                                    <td style={{ padding: "12px 16px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                                            <div style={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                color: "#1e293b",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                flexWrap: "wrap"
                                                            }}>
                                                                <span style={{
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    maxWidth: "300px"
                                                                }}>
                                                                    {section.className}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </td>

                                                    <td style={{ padding: "12px 16px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                                            <div style={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                color: "#1e293b",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                flexWrap: "wrap"
                                                            }}>
                                                                <span style={{
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    maxWidth: "300px"
                                                                }}>
                                                                    {section.sectionName}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </td>

                                                    <td style={{ padding: "12px", textAlign: "center" }}>
                                                        <div style={{
                                                            display: "flex",
                                                            gap: "6px",
                                                            justifyContent: "center",
                                                            flexWrap: "wrap"
                                                        }}>
                                                            {userPermissions.is_edit === "1" && (
                                                                <button
                                                                    onClick={() => handleEdit(section)}
                                                                    title="Edit Section"
                                                                    style={{
                                                                        width: "32px",
                                                                        height: "32px",
                                                                        borderRadius: "8px",
                                                                        border: "none",
                                                                        background: "#eff6ff",
                                                                        color: "#3b82f6",
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        transition: "all 0.2s",
                                                                        flexShrink: 0
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.background = "#dbeafe"}
                                                                    onMouseLeave={(e) => e.target.style.background = "#eff6ff"}
                                                                >
                                                                    <PencilSimpleLine size={14} />
                                                                </button>
                                                            )}

                                                            {userPermissions.is_delete === "1" && (
                                                                <button
                                                                    onClick={() => handleDelete(section.id)}
                                                                    title="Delete Section"
                                                                    style={{
                                                                        width: "32px",
                                                                        height: "32px",
                                                                        borderRadius: "8px",
                                                                        border: "none",
                                                                        background: "#fef2f2",
                                                                        color: "#dc2626",
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        transition: "all 0.2s",
                                                                        flexShrink: 0
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.background = "#fee2e2"}
                                                                    onMouseLeave={(e) => e.target.style.background = "#fef2f2"}
                                                                >
                                                                    <Trash size={14} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        {/* Compact Pagination */}
                        {!dataLoading && fetchedData.length > 0 && (
                            <div style={{
                                padding: "16px 20px",
                                borderTop: "1px solid #e5e7eb",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: "12px",
                                fontSize: "13px"
                            }}>
                                <div style={{ color: "#64748b" }}>
                                </div>
                                <div style={{ display: "flex", gap: "4px" }}>
                                    <button
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        style={{
                                            padding: "6px 12px",
                                            background: currentPage === 1 ? "#f1f5f9" : "#fff",
                                            color: currentPage === 1 ? "#94a3b8" : "#334155",
                                            border: "1px solid #e5e7eb",
                                            borderRadius: "6px",
                                            cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                            fontSize: "12px",
                                            transition: "all 0.2s",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}
                                    >
                                        ← Prev
                                    </button>

                                    <div style={{ display: "flex", gap: "2px" }}>
                                        {createPagination().map((page, index) => (
                                            <button
                                                key={index}
                                                onClick={() => typeof page === "number" && handlePageChange(page)}
                                                style={{
                                                    padding: "6px 10px",
                                                    background: currentPage === page ? "#3E80F9" : "#fff",
                                                    color: currentPage === page ? "#fff" : "#334155",
                                                    border: "1px solid #e5e7eb",
                                                    borderRadius: "6px",
                                                    cursor: typeof page === "number" ? "pointer" : "default",
                                                    fontSize: "12px",
                                                    minWidth: "32px",
                                                    transition: "all 0.2s",
                                                    fontWeight: currentPage === page ? "600" : "500"
                                                }}
                                                disabled={page === "..."}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                    </div>

                                    <button
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        style={{
                                            padding: "6px 12px",
                                            background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                                            color: currentPage === totalPages ? "#94a3b8" : "#334155",
                                            border: "1px solid #e5e7eb",
                                            borderRadius: "6px",
                                            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                            fontSize: "12px",
                                            transition: "all 0.2s",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}
                                    >
                                        Next →
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* Modal for Add/Edit Section */}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton style={{
                    borderBottom: "1px solid #e5e7eb",
                    padding: "14px 24px",
                    background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                    color: "#fff"
                }}>
                    <div>
                        <Modal.Title style={{ fontSize: "20px", fontWeight: "700", marginBottom: "4px" }}>
                            {ID ? "✏️ Edit Section" : "➕ Add New Section"}
                        </Modal.Title>

                    </div>
                </Modal.Header>
                <Modal.Body style={{
                    padding: "28px",
                    background: "#f8fafc"
                }}>
                    <form onSubmit={handleSubmit}>

                        <div style={{ marginBottom: "20px" }}>
                            <label
                                style={{
                                    display: "block",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#475569",
                                    marginBottom: "8px"
                                }}
                            >
                                Class <span style={{ color: "#dc2626" }}>*</span>
                            </label>

                            <select
                                value={selectedClass}
                                onChange={(e) => setSelectedClass(e.target.value)}
                                required
                                style={{
                                    width: "100%",
                                    padding: "12px 16px",
                                    borderRadius: "10px",
                                    border: "1px solid #e2e8f0",
                                    fontSize: "14px",
                                    background: "#fff"
                                }}
                            >
                                <option value="">Select Class</option>

                                {classes.map((cls) => (
                                    <option key={cls.id} value={cls.id}>
                                        {cls.className}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={{ marginBottom: "20px" }}>
                            <label htmlFor="sectionName" style={{
                                display: "block",
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#475569",
                                marginBottom: "8px"
                            }}>
                                Section Name <span style={{ color: "#dc2626" }}>*</span>
                            </label>
                            <input
                                type="text"
                                id="sectionName"
                                placeholder="Enter class name"
                                value={sectionName}
                                onChange={(e) => setSectionName(e.target.value)}
                                required
                                style={{
                                    width: "100%",
                                    padding: "12px 16px",
                                    borderRadius: "10px",
                                    border: "1px solid #e2e8f0",
                                    fontSize: "14px",
                                    outline: "none",
                                    transition: "all 0.2s",
                                    background: "#fff"
                                }}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer style={{
                    borderTop: "1px solid #e5e7eb",
                    padding: "24px 28px",
                    background: "#f8fafc"
                }}>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                        style={{
                            background: "#f1f5f9",
                            color: "#475569",
                            border: "none",
                            padding: "10px 24px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            fontWeight: "600",
                            transition: "all 0.2s",
                            cursor: "pointer"
                        }}
                        onMouseEnter={(e) => e.target.style.background = "#e2e8f0"}
                        onMouseLeave={(e) => e.target.style.background = "#f1f5f9"}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={loading}
                        style={{
                            background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                            color: "#fff",
                            border: "none",
                            padding: "10px 24px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            opacity: loading ? 0.7 : 1
                        }}
                        onMouseEnter={(e) => !loading && (e.target.style.transform = "translateY(-2px)")}
                        onMouseLeave={(e) => !loading && (e.target.style.transform = "translateY(0)")}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{ marginRight: "8px" }}
                                />
                                {buttonText}
                            </>
                        ) : (
                            buttonText
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer position="top-right" autoClose={3000} />

            <style>
                {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          input:hover, select:hover {
            border-color: #94a3b8 !important;
          }
          
          input:focus, select:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
            </style>
        </div>
    );
};

export default Sections;